// src/Components/ConfirmModal.js
import React from "react";
import "./ConfirmModal.css";
import DangerIcon from "../../../../Assets/Danger.png"; // ✅ Import from Assets folder

export default function ConfirmModal({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <img src={DangerIcon} alt="Warning" className="modal-icon" />
        <h2 className="modal-title">{title}</h2>
        <p className="modal-message">{message}</p>
        <div className="modal-actions">
          <button className="cancel-btn" onClick={onCancel}>
            Cancel
          </button>
          <button className="confirm-btn" onClick={onConfirm}>
            Clear Cart
          </button>
        </div>
      </div>
    </div>
  );
}
